import { Modal } from 'react-bootstrap';
import { ZdarKidsGameContext } from '../../../../contexts/ZdarKidsGameContext';
import { useLottie } from 'lottie-react';
import Button from '../../../common/buttons/Button';
import React, { useContext } from 'react';
import coinsAnimation from '../../../../assets/images/games/zdar-kids-game/coins.json';

type Props = {
    fallback: () => void;
    hintsTaken: number;
};

export default function ZdarKidsPointsModal({ fallback, hintsTaken }: Props) {
    const { pointsModalOpen, closePointsModal } = useContext(ZdarKidsGameContext);

    return (
        <React.Fragment>
            <Modal dialogClassName="zdar-kids-points-modal" show={pointsModalOpen}>
                <Modal.Header>
                    <Modal.Title>Úloha splněna</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {hintsTaken > 0 && <div>Za úlohu jste nezískali žádné mince.</div>}
                    {hintsTaken === 0 && (
                        <div>
                            Získali ste <span className="zdar-kids-big-letter">10</span> mincí.
                        </div>
                    )}
                    <div className="points-modal-coins">
                        <CoinsImage />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="secondary-button"
                        onClick={() => {
                            closePointsModal();
                            fallback();
                        }}
                    >
                        Pokračovat
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
}

const CoinsImage = () => {
    const options = {
        animationData: coinsAnimation,
        loop: true,
        autoplay: true,
    };

    const { View } = useLottie(options);

    return View;
};
